import { Action } from '@tribeplatform/gql-client/global-types'
import { ActionFields } from '@tribeplatform/gql-client/graphql'
import type { ClientError } from '@tribeplatform/gql-client/lib'
import { MutationDeleteSpaceContentModuleArgs } from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import {
  getSpaceContentModulesKey,
  getSpaceKey,
} from '../../utils/keys/space.key.js'

export const useDeleteSpaceContentModule = (options?: {
  fields?: ActionFields
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationDeleteSpaceContentModuleArgs
  >
}) => {
  const { useMutationOptions, fields } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Action, ClientError, MutationDeleteSpaceContentModuleArgs>(
    (input: MutationDeleteSpaceContentModuleArgs) =>
      client.spaces.deleteContentModule(input, fields),
    {
      ...useMutationOptions,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(
          getSpaceContentModulesKey({
            variables: { spaceId: variables.spaceId },
          }),
        )
        queryClient.invalidateQueries(
          getSpaceKey({
            variables: {
              id: variables.spaceId,
            },
          }),
        )
        useMutationOptions?.onSuccess?.(data, variables, context)
      },
    },
  )
}
